import { gql, useQuery } from "@apollo/client";
import { 
  FindRefundByIdAdminQueryQuery, 
  QueryFindRefundByIdAdminArgs
} from "../../../../../schemaTypes";

export const findRefundByIdAdminQuery = gql`
  query FindRefundByIdAdminQuery(
    $id: String!
  ) {
    findRefundByIdAdmin(
      id: $id
    ) {
      id
      amount
      reasonForRefund
      description
      customerName
      transactionId
    	transaction {
        id
        offer{
          id
          title
          offerType
        }
      }
      createdAt
      reference
      status
      currency
    	userId
    	user {
        id
        admin{
          id
          merchantProfile{
            companyName
            businessName
          }
        }
      }
      admin {
        id
        firstname
        lastname
      }
    }
  }
`;

export interface RefundTransaction {
  id: string;
  offer?: {
    id: string;
    title: string;
    offerType?: string | null;
  } | null;
}

export interface RefundAdmin {
  id: string;
  firstname?: string | null;
  lastname?: string | null;
}

export interface RefundUser {
  id: string;
  admin?: {
    id: string;
    merchantProfile?: {
      companyName?: string | null;
      businessName?: string | null;
    } | null;
  } | null;
}

export interface WithFindRefundByIdAdmin {
  id: string
  amount: number
  reasonForRefund: string
  description: string
  customerName: string
  transactionId: string
  createdAt: string
  reference: string
  status: string
  currency: string,
  userId: string,
  transaction?: RefundTransaction | null,
  admin?: RefundAdmin | null,
  user?: RefundUser | null
}

interface Props {
  variables: QueryFindRefundByIdAdminArgs;
  children: (data: WithFindRefundByIdAdmin) => React.ReactElement | null;
}

export const FindRefundByIdAdminController: React.FC<Props> = ({ children, variables }) => {
  const { data } = useQuery<
    FindRefundByIdAdminQueryQuery,
    QueryFindRefundByIdAdminArgs
  >(findRefundByIdAdminQuery, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  const id = data?.findRefundByIdAdmin?.id || "";
  const amount = data?.findRefundByIdAdmin?.amount || 0; 
  const reasonForRefund = data?.findRefundByIdAdmin?.reasonForRefund || "";
  const description = data?.findRefundByIdAdmin?.description || "";
  const customerName = data?.findRefundByIdAdmin?.customerName || "";
  const transactionId = data?.findRefundByIdAdmin?.transactionId || "";
  const createdAt = data?.findRefundByIdAdmin?.createdAt || "";
  const reference = data?.findRefundByIdAdmin?.reference || "";
  const status = data?.findRefundByIdAdmin?.status || "";
  const currency = data?.findRefundByIdAdmin?.currency || "";
  const userId = data?.findRefundByIdAdmin?.userId || "";
  const transaction = data?.findRefundByIdAdmin?.transaction || null;
  const admin = data?.findRefundByIdAdmin?.admin || null;
  const user = data?.findRefundByIdAdmin?.user || null;


  return children({
        id,
        amount,
        reasonForRefund,
        description,
        customerName,
        transactionId,
        createdAt,
        reference,
        status,
        currency,
        userId,
        transaction,
        admin,
        user
  });
};
